import React from 'react'
import Header from './Header'
// import Breadcrumb from './Breadcrumb'
import Routes from './Routes'
import Footer from './Footer'
import { Container} from 'semantic-ui-react'

export default () => (
    <div>
        <Header />
        {/* <Breadcrumb /> */}
        <Container style={{ minHeight: '219px',marginBottom: '5rem' }}>
            <Routes />
        </Container>
        <Footer />
    </div>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/App.js